/* @jsxImportSource react */

import React, { useMemo } from 'react';
import { useGLTF, useTexture } from '@react-three/drei';
import { FresnelMatcap } from './FresnelMatcap.js';
import { buildPublicUrl } from '@/lib/globals.ts';
import sphere1Texture from '@/img/Sphere_1_Reflection_MatCap_1024.jpg';
import sphere2Texture from '@/img/Sphere_2_Reflection_MatCap_1024.jpg';
import sphere3Texture from '@/img/Sphere_3_Reflection_MatCap_1024.jpg';
import sphere4Texture from '@/img/Sphere_4_Reflection_MatCap_1024.jpg';
import sphere5Texture from '@/img/Sphere_5_Reflection_MatCap_1024.jpg';

export const URL = buildPublicUrl('3d/OnlyBots_WebGL_Environment_003.glb');

export { sphere1Texture, sphere2Texture, sphere3Texture, sphere4Texture, sphere5Texture };
const textureUrls = [sphere1Texture, sphere2Texture, sphere3Texture, sphere4Texture, sphere5Texture];

const SPHERE_SCALAR = 1.2;
export const Spheres = React.memo(() => {
    const { nodes } = useGLTF(URL);

    //MatCap Materials
    const textures = useTexture(textureUrls);

    const fresnelMatcapMaterial1 = useMemo(() => new FresnelMatcap({ matcap: textures[0] }), [textures]);
    const fresnelMatcapMaterial2 = useMemo(() => new FresnelMatcap({ matcap: textures[1] }), [textures]);
    const fresnelMatcapMaterial3 = useMemo(() => new FresnelMatcap({ matcap: textures[2] }), [textures]);
    const fresnelMatcapMaterial4 = useMemo(() => new FresnelMatcap({ matcap: textures[3] }), [textures]);
    const fresnelMatcapMaterial5 = useMemo(() => new FresnelMatcap({ matcap: textures[4] }), [textures]);

    return (
        <group scale={0.6} position={[0, -3, 0]} dispose={null}>
            <mesh
                scale={3 * SPHERE_SCALAR}
                position={[-15, 3, 23]}
                geometry={nodes.Ball_Sphere_Solo.geometry}
                material={fresnelMatcapMaterial1}
            />
            <mesh
                scale={8 * SPHERE_SCALAR}
                position={[-10, 34, 0]}
                geometry={nodes.Ball_Sphere_Solo.geometry}
                material={fresnelMatcapMaterial2}
            />
            <mesh
                scale={10 * SPHERE_SCALAR}
                position={[15, 30, 15]}
                geometry={nodes.Ball_Sphere_Solo.geometry}
                material={fresnelMatcapMaterial3}
            />
            <mesh
                scale={7 * SPHERE_SCALAR}
                position={[30, 8, -10]}
                geometry={nodes.Ball_Sphere_Solo.geometry}
                material={fresnelMatcapMaterial4}
            />
            <mesh
                scale={16 * SPHERE_SCALAR}
                position={[-30, 30, -30]}
                geometry={nodes.Ball_Sphere_Solo.geometry}
                material={fresnelMatcapMaterial5}
            />
        </group>
    );
});
